<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{$t('common.date')}}</span>
      <el-date-picker
        v-model="changeValue"
        :placeholder="$t('common.search.dateSearch')"
        value-format="yyyy-MM"
        type="month"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataPage">
      <el-row class="pageCost">
        <el-col :span="16">
          <div class="halfTitle">{{$t('MaintenanceAnalysis.repairCostCompar')}}</div>
          <div v-if="isShow" v-loading="costLoading">
            <linegraph
              :id="'linegraph'"
              :data="costOption"
              style="height: 310px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}}</div>
        </el-col>
        <el-col :span="8">
          <div v-if="isValue" v-loading="pieLoading">
            <linegraph
              :id="'piegraph'"
              :data="optionPie"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="dataTable">
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('MaintenanceAnalysis.carId')">
            <el-input
              size="mini"
              v-model="formInline.carId"
              :placeholder="$t('MaintenanceAnalysis.form.carId')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('MAINTENANCEANALYSIS_CHANGE_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>